// extracted by mini-css-extract-plugin
export default {"container":"LxGLUz","info":"FCuaNK","infoApps":"WVXIJS","infoContainer":"lpTR2z","title":"m7imRI","description":"uw7AES","appsContainer":"wnrG9k","apps":"GfVoGd"};